import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Sparkles, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function UpgradeModal({ open, feature, onClose }) {
  const navigate = useNavigate();
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4" data-testid="upgrade-modal">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-xl overflow-hidden">
        <div className="bg-[#27292E] text-white px-5 py-4 flex items-start justify-between">
          <div>
            <div className="text-[11px] tracking-widest uppercase text-amber-300 font-bold flex items-center gap-1"><Sparkles className="w-3.5 h-3.5" /> ProPortal Pro</div>
            <h2 className="text-lg font-bold mt-1">Unlock texting to customers &amp; crew</h2>
          </div>
          <button type="button" onClick={onClose} className="p-1 rounded hover:bg-white/10" aria-label="Close" data-testid="upgrade-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-sm text-gray-700 flex items-start gap-2"><Lock className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" />{feature || 'This feature'} is included in <strong className="mx-1">Pro</strong> — £19.99/month, cancel any time.</p>
          <ul className="text-sm text-gray-700 space-y-1.5 list-disc pl-5">
            <li>Text customers their confirmed install dates with one tap</li>
            <li>Text your crew their day sheet — jobs, addresses, times</li>
            <li>No limits on texts — we cover the cost</li>
            <li>Website contact form without the “Powered by” footer</li>
          </ul>
          <div className="flex gap-2 pt-1">
            <Button variant="outline" onClick={onClose} className="flex-1" data-testid="upgrade-later">Not now</Button>
            <Button onClick={() => { onClose(); navigate('/billing'); }} className="flex-1 bg-[#006400] hover:bg-[#004d00] text-white" data-testid="upgrade-go">See Pro plan</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ProBadge({ className = '' }) {
  return <span className={`inline-flex items-center gap-0.5 text-[10px] font-bold uppercase tracking-wide bg-amber-100 text-amber-800 rounded px-1.5 py-0.5 ${className}`} data-testid="pro-badge"><Lock className="w-2.5 h-2.5" /> Pro</span>;
}
